import { useEffect, useRef } from "react";

export default function Textarea({
  label,
  value,
  onChange,
  rows = 4,
  placeholder = "",
  className = "",
  ...props
}) {
  const textareaRef = useRef(null);

  useEffect(() => {
    const textarea = textareaRef.current;
    if (textarea) {
      textarea.style.height = "auto";
      textarea.style.height = `${textarea.scrollHeight}px`;
    }
  }, [value]);

  return (
    <div className={className}>
      {label && (
        <label className="block text-sm font-medium mb-1">{label}</label>
      )}
      <textarea
        ref={textareaRef}
        value={value}
        onChange={onChange}
        rows={rows}
        placeholder={placeholder}
        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 focus:outline-none transition resize-y min-h-[100px]"
        {...props}
      />
    </div>
  );
}
